import { makeObservable, observable, action } from 'mobx';
import { bogLineMinOdd, defaultMinOdd } from '../../enums/BogLineGameConfig.js';

var GameStore = /** @class */ (function () {
    function GameStore() {
        this.minOdd = bogLineMinOdd;
        this.defaultMinOdd = defaultMinOdd;
        this.partnerWageringOdd = null;
        this.partnerWageringDisabled = null;
        this.isBetsClosed = false;
        this.numPadData = {
            isOpen: false,
            sectionName: null,
            currentInputValue: null,
            numPadLimits: {},
            isOpenNumpad: false,
            sectionIndex: null,
        };
        this.isPongReceived = false;
        this.currentGameState = null;
        this.showPopUpsWhitData = {
            popUpIndex: null,
            data: null,
        };
        this.userCounts = 0;
        this.cashOutCounts = 0;
        this.storeTimeoutIds = {
            timeoutId: null,
        };
        makeObservable(this, {
            userCounts: observable,
            cashOutCounts: observable,
            storeTimeoutIds: observable,
            showPopUpsWhitData: observable,
            currentGameState: observable,
            partnerWageringOdd: observable,
            partnerWageringDisabled: observable,
            isBetsClosed: observable,
            numPadData: observable.deep,
            isPongReceived: observable,
            setNumPadData: action.bound,
            setIsBetsClosed: action.bound,
            setIsPongReceived: action.bound,
            setMinOdd: action.bound,
            setDefaultMinOdd: action.bound,
            setPartnerWageringOdd: action.bound,
            setCurrentGameState: action.bound,
            setPartnerWageringDisabled: action.bound,
            setShowPopUpsWhitIndex: action.bound,
            increaseUserCounts: action,
            clearUserCounts: action,
            increaseCashOutCounts: action,
            clearCashOutCounts: action,
            clearTimeoutAction: action.bound,
        });
    }
    GameStore.prototype.increaseUserCounts = function (value) {
        if (value) {
            this.userCounts = value;
        }
        else {
            this.userCounts += 1;
        }
    };
    GameStore.prototype.clearUserCounts = function () {
        this.userCounts = 0;
    };
    GameStore.prototype.increaseCashOutCounts = function () {
        this.cashOutCounts += 1;
    };
    GameStore.prototype.clearCashOutCounts = function () {
        this.cashOutCounts = 0;
    };
    GameStore.prototype.clearTimeoutAction = function () {
        for (var key in this.storeTimeoutIds) {
            if (this.storeTimeoutIds[key]) {
                clearTimeout(this.storeTimeoutIds[key]);
                this.storeTimeoutIds[key] = null;
            }
        }
    };
    GameStore.prototype.setShowPopUpsWhitIndex = function (index, data) {
        this.showPopUpsWhitData.popUpIndex = index;
        this.showPopUpsWhitData.data = data;
    };
    GameStore.prototype.setPartnerWageringDisabled = function (bool) {
        this.partnerWageringDisabled = bool;
    };
    GameStore.prototype.setCurrentGameState = function (stateName) {
        this.currentGameState = stateName;
    };
    GameStore.prototype.setMinOdd = function (value) {
        this.minOdd = value;
    };
    GameStore.prototype.setDefaultMinOdd = function (value) {
        this.defaultMinOdd = value;
    };
    GameStore.prototype.setPartnerWageringOdd = function (value) {
        this.partnerWageringOdd = value;
    };
    GameStore.prototype.setIsPongReceived = function (isPongReceived) {
        this.isPongReceived = isPongReceived;
    };
    GameStore.prototype.setIsBetsClosed = function (isBetsClosed) {
        this.isBetsClosed = isBetsClosed;
    };
    GameStore.prototype.setNumPadData = function (data) {
        this.numPadData = data;
    };
    return GameStore;
}());
var gameStore = new GameStore();

export { gameStore };
